import type { ReactNode } from 'react';
import { colors } from '../../styles/theme';

interface PageHeaderProps {
  /** Main page title — rendered as <h1>. */
  title: string;
  /** Short context line under the title. Optional. */
  subtitle?: ReactNode;
  /** Right-aligned slot for actions (buttons, links, filters). */
  actions?: ReactNode;
}

/**
 * Standard page header used by every screen rendered inside MainLayout.
 *
 * Centralising title + subtitle + actions guarantees vertical rhythm and
 * typography stay consistent across roles. Pages should NOT render their
 * own <h1> at the top — let this component own that slot.
 */
const PageHeader = ({ title, subtitle, actions }: PageHeaderProps): JSX.Element => (
  <div className="flex items-start justify-between gap-4 mb-8 flex-wrap">
    <div className="min-w-0">
      <h1 className="text-2xl font-bold tracking-tight" style={{ color: colors.ink }}>
        {title}
      </h1>
      {subtitle && (
        <div className="mt-1 text-sm" style={{ color: colors.muted }}>
          {subtitle}
        </div>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
